const JobTypeTranslation = {
  "sales-agent-support": "Sales agent求人",
  "shared-job": "自社求人", //this is for the job  which is already used and are stored in database
  "direct-job": "ダイレクト求人",
  "internal-job": "自社求人", //this is for the job which are new job
}

export { JobTypeTranslation }
